<template>
  <Header header__white="header__white" />
  <Breadcrumb title="Hakkımızda" subtitle="Hakkımızda" />
  <AboutArea/>
  <!-- <BannerArea/> -->
  <Footer footerPadding="true" />
</template>

<script>
import Header from '../components/Home/Header.vue';
import Breadcrumb from '../components/common/Breadcrumb.vue';
import AboutArea from '../components/common/AboutArea.vue';
// import BannerArea from '../components/Home/BannerArea.vue';
import Footer from '../components/Home/Footer.vue';

export default {
    name:'AboutPage',
    components:{
        Header,
        Breadcrumb,
        AboutArea,
        // BannerArea,
        Footer,
    }
}
</script>
